var _window, _window2, _userCookieUtils$getU;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { HoneycombWebSDK } from '@honeycombio/opentelemetry-web';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { userCookieUtils } from 'common/report/util/user-identity-from-cookie';
import { ImperativeContextManager } from 'common/util/tracing';
import { applyQueryHeaderAttributesToFetchSpan, applyQueryHeaderAttributesToXhrSpan, FetchSpanWrapperProcessor, HttpUrlPathProcessor } from './honeycomb-span-processors';
import { detectBrowserAutomation } from './detect-browser-automation';
const configDefaults = {
  ignoreNetworkEvents: true,
  propagateTraceHeaderCorsUrls: [
  // adds span trace ids to all request on mixpanel domains
  /^https:\/\/(.+\.)?mixpanel\.(com|org)/g],
  ignoreUrls: [
  // Specific first-party URLs we want to ignore
  /mixpanel\.(com|org)\/tproxy/,
  // Allow list of domains we care about
  /^(?!.*(mixpanel\.(com|org)|mxpnl\.com|web-internal|storage\.googleapis\.com|zendesk\.com)).*$/]
};

// Honeycomb Core Web Vitals are high volume and we don't really use them
let recordCoreWebVitalsPercent = 10;
// Don't record web vitals for automated browsers like screenshot server
// - The compute resources available to an automated runner are not representative of a real user
// - It's just noise
if (detectBrowserAutomation({
  userAgent: (_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent,
  host: (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.host
})) {
  recordCoreWebVitalsPercent = 0;
}
const shouldRecordCoreWebVitals = recordCoreWebVitalsPercent > 0 && Math.random() * 100 <= recordCoreWebVitalsPercent;

/**
 * @see https://docs.honeycomb.io/send-data/javascript-browser/honeycomb-distribution/
 */
const sdk = new HoneycombWebSDK({
  /** set debug & localVisualizations to true for local debugging on traces */
  debug: false,
  localVisualizations: false,
  apiKey: HONEYCOMB_TOKEN,
  serviceName: "web-client",
  instrumentations: [getWebAutoInstrumentations({
    '@opentelemetry/instrumentation-document-load': _objectSpread(_objectSpread({}, configDefaults), {}, {
      ignorePerformancePaintEvents: !shouldRecordCoreWebVitals
    }),
    '@opentelemetry/instrumentation-fetch': _objectSpread(_objectSpread({}, configDefaults), {}, {
      applyCustomAttributesOnSpan: applyQueryHeaderAttributesToFetchSpan
    }),
    '@opentelemetry/instrumentation-user-interaction': {
      enabled: false
    },
    '@opentelemetry/instrumentation-xml-http-request': _objectSpread(_objectSpread({}, configDefaults), {}, {
      applyCustomAttributesOnSpan: applyQueryHeaderAttributesToXhrSpan
    })
  })],
  webVitalsInstrumentationConfig: {
    enabled: shouldRecordCoreWebVitals
  },
  resourceAttributes: {
    user_id: (_userCookieUtils$getU = userCookieUtils.getUserIdentityFromCookie()) === null || _userCookieUtils$getU === void 0 ? void 0 : _userCookieUtils$getU.id,
    bundler: process.env.BUNDLER
  },
  contextManager: new ImperativeContextManager(),
  spanProcessors: [new HttpUrlPathProcessor(), new FetchSpanWrapperProcessor()]
});
sdk.start();